import React from 'react';

const WithPaddingAndActionsRenderer: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
  <div className="n-table-content n-table-content--with-padding n-table-content--with-actions">
    {children}
  </div>
);

export default WithPaddingAndActionsRenderer;
